import ReactDOM from "react-dom";
import type { ComponentProps, ReactNode } from "react";

import { ErrorBoundary } from "@/appComponents/Blocks/Utils/ErrorBoundary/ErrorBoundary";

/*
 * This component assists with escaping the document's
 * stacking context and allowing modals with higher
 * z-indexes to be drawn above the nav and toolbars
 * Reference: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_positioned_layout/Understanding_z-index/Stacking_context
 */
type Props = {
  children: ReactNode;
  errorBoundaryProps?: ComponentProps<typeof ErrorBoundary>;
  show: boolean;
};

const CentralizedModalContainer = (props: Props) => {
  if (!props.show) return null;

  const target = document.getElementById("modal-root");

  if (!target) return null;
  return ReactDOM.createPortal(
    <ErrorBoundary {...props.errorBoundaryProps}>{props.children}</ErrorBoundary>,
    target
  );
};

export default CentralizedModalContainer;
